(function($) {
    $.widget("ca.caAutolist", {
        _create : function() {
            // Get data and hide original input
            var values = $(this.element).val().split(',');
            var curr_id = $(this.element).attr('id');
            $('#' + curr_id).hide();

            // Create control options
            var control_options = $('<ul class="autolist-control-data"></ul>');
            if (this.options.data.length > 0) {
                for (var i = 0; i < this.options.data.length; i++) {
                    if (this.options.data[i] != '') {
                        var checked = '';
                        if (values.indexOf(this.options.data[i].id) != -1) {
                            checked = 'checked';
                        }

                        // Add new item to list
                        var list_id = curr_id + '-autolist-item-' + this.options.data[i].id;
                        control_options.append(
                            '<li id="' + list_id + '" rel="' + this.options.data[i].id + '" class="' + checked + '">' +
                                this.options.data[i].name +
                            '</li>'
                        );

                        // Bind click to item
                        $('#' + list_id).live('click', function() {
                            // Update "check" status
                            $(this).toggleClass('checked');

                            // Get data
                            var value = $(this).attr('rel');
                            var curr_id = $(this).closest('div.autolist-control').attr('rel');

                            // Get all values and current value index
                            var value_set = $('#' + curr_id).val().split(',');
                            var index = value_set.indexOf(value);

                            // Add or remove current value
                            if (index != -1) {
                                value_set.splice(index, 1);
                            } else {
                                value_set.push(value);
                            }
                            $('#' + curr_id).val(value_set.join(','));
                        });
                    }
                }
            }

            // Insert new control markup
            $('#' + curr_id).after(
                '<div class="autolist-control" rel="' + curr_id + '">' +
                    '<div class="autolist-control-head">' +
                        $(this.element).attr('title') +
                    '</div>' +
                    control_options[0].outerHTML +
                '</div>'
            );
        }
    });
})(jQuery);
